import Brett from "./Brett";
import Spiegel from "./Spiegel";

export default class Front extends Brett {
    // DO NOT CHANGE
    className = "Front";


    type = 'standard'; // 'glas'|'spiegel'|'standard'
    spiegel: ?Spiegel;
    spiegelbasis: ?Brett;

    constructor(parent, artikelnummer, mainAxes) {
        super(parent, artikelnummer, mainAxes);
    }

    compile() {

        const isSpiegel = this.type === 'spiegel';

        if (isSpiegel && !this.spiegel) {
            this.spiegelbasis = new Brett(this.parent, this.product.Artikelnummer, 'yx');
            this.spiegelbasis.fixedMaterialKey = 'spiegel';
            this.spiegel = new Spiegel(this.parent, this.spiegelbasis);
        } else if (!isSpiegel && this.spiegel) {
            this.spiegel = null;
            this.spiegelbasis = null;
        }

        const rand = this.schrank.options.getFloat('tuer_spiegel_abstand');
        const schiebetuer_spiegel_dicke = this.schrank.options.getFloat('schiebetuer_spiegel_dicke',1.6);
        const tuer_spiegel_dicke = this.schrank.options.getFloat('tuer_spiegel_dicke');

        if (this.spiegel) {
            this.box.max.z = this.box.min.z + schiebetuer_spiegel_dicke;
        }

        this.boxToVertices();
        super.compile();

        if (this.spiegel) {
            const b = this.spiegelbasis.box;
            b.copy(this.box);
            b.min.z = this.box.max.z;
            b.max.z = b.min.z + tuer_spiegel_dicke;
            b.min.x += rand;
            b.max.x -= rand;
            b.min.y += rand;
            b.max.y -= rand;
            this.spiegelbasis.boxToVertices();

            this.spiegelbasis.compile();
            this.spiegel.compile();
        }
    }

    iterate(iterator) {
        super.iterate(iterator);
        this.spiegel && iterator(this.spiegel);
        this.spiegelbasis && iterator(this.spiegelbasis);
    }

}

